/**
 * LE PANNEAU — une page posée sur la page.
 *
 * Le fond froissé est un pseudo-élément (voir `matiere.css`) ; ici on n'ajoute que les ORNEMENTS DE
 * COIN, dessinés, et le titre gravé quand il y en a un. Quatre volutes suffisent à sortir du
 * rectangle web ; un cadre entier ferait cartouche de diplôme.
 */
import type { ReactNode } from "react";

function Volute() {
  return (
    <svg className="ornement ornement--hg" viewBox="0 0 26 26" aria-hidden="true">
      <path d="M1 9V4a3 3 0 0 1 3-3h5" />
      <path d="M4 12V7a3 3 0 0 1 3-3h5" />
      <path d="M7 4.5c2.5 0 4 1.4 4 3" />
    </svg>
  );
}

interface Props {
  children: ReactNode;
  titre?: ReactNode;
  /** Creusé : la carte, un encadré secondaire. Levé : ce qui doit passer devant. */
  variante?: "pose" | "creux" | "leve";
  serre?: boolean;
  ornements?: boolean;
  className?: string;
}

export function Parchemin({ children, titre, variante = "pose", serre = false, ornements = true, className }: Props) {
  const classes = [
    "parchemin",
    variante === "creux" ? "parchemin--creux" : "",
    variante === "leve" ? "parchemin--levee" : "",
    serre ? "parchemin--serre" : "",
    className ?? ""
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <section className={classes}>
      {ornements ? (
        <>
          <Volute />
          <svg className="ornement ornement--hd" viewBox="0 0 26 26" aria-hidden="true">
            <path d="M1 9V4a3 3 0 0 1 3-3h5" />
            <path d="M4 12V7a3 3 0 0 1 3-3h5" />
            <path d="M7 4.5c2.5 0 4 1.4 4 3" />
          </svg>
          <svg className="ornement ornement--bg" viewBox="0 0 26 26" aria-hidden="true">
            <path d="M1 9V4a3 3 0 0 1 3-3h5" />
            <path d="M4 12V7a3 3 0 0 1 3-3h5" />
            <path d="M7 4.5c2.5 0 4 1.4 4 3" />
          </svg>
          <svg className="ornement ornement--bd" viewBox="0 0 26 26" aria-hidden="true">
            <path d="M1 9V4a3 3 0 0 1 3-3h5" />
            <path d="M4 12V7a3 3 0 0 1 3-3h5" />
            <path d="M7 4.5c2.5 0 4 1.4 4 3" />
          </svg>
        </>
      ) : null}
      {titre ? <h3 style={{ marginBottom: "var(--e4)" }}>{titre}</h3> : null}
      {children}
    </section>
  );
}

/** Le filet ornemental : deux traits et un losange. Il sépare sans encadrer. */
export function Filet({ children }: { children?: ReactNode }) {
  return (
    <div className="filet" aria-hidden={children ? undefined : true}>
      {children ? <span className="capitales">{children}</span> : <span style={{ fontSize: "0.7rem" }}>◆</span>}
    </div>
  );
}
